import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Помечаем факт монтирования (используется safety-таймаутом из index.html)
try {
  window.__reactMounted = true;
  if (typeof window.__diagEv === 'function') window.__diagEv('react:module-loaded');
} catch (_) {}

const container = document.getElementById('root');
// Если в root остался статический пре-лоадер из index.html - убираем, чтобы не мигал
try {
  const pre = document.getElementById('pre-loader');
  if (pre && pre.parentNode) pre.parentNode.removeChild(pre);
} catch (_) {}

const root = ReactDOM.createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
